import type { Insight } from '@/types/insights';
import { insightPayloadAxes } from '@/utils/insights/insightAxis';

export type InsightGenerationPhase = {
  /** 最初の軸が公開されるまで。進捗バーと展開ボタンの出し分けに使う */
  isAwaitingFirstAxis: boolean;
  canOpen: boolean;
  /** 全軸が確定している。既読演出はこれを条件にする */
  isFullyGenerated: boolean;
};

/**
 * 再生成直後は前回の processed の発想のヒントが返り、公開済みの軸を持っているため、
 * 軸の状態より isRegenerating を優先して最初の軸の公開待ちとみなす。
 */
export const resolveInsightGenerationPhase = (
  data: Insight | undefined,
  isRegenerating: boolean,
): InsightGenerationPhase => {
  const status = data?.generation_status;
  const isGenerating =
    isRegenerating || status === 'unprocessed' || status === 'processing';

  const axes = data?.payload ? insightPayloadAxes(data.payload) : [];
  const anyAxisProcessed = axes.some(
    axis => axis.generation_status === 'processed',
  );
  const allAxesSettled =
    axes.length > 0 &&
    axes.every(axis => axis.generation_status !== 'processing');
  const isAwaitingFirstAxis =
    isRegenerating || (isGenerating && !anyAxisProcessed);

  return {
    isAwaitingFirstAxis,
    canOpen: data !== undefined && !isAwaitingFirstAxis,
    // 全体が error になるのは「あなたの関心」が失敗したときで、全体エラーの表示になるため既読演出の対象外にする
    isFullyGenerated:
      !isRegenerating &&
      status !== 'error' &&
      status !== 'unprocessed' &&
      allAxesSettled,
  };
};
